var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10.1924C18 14.6107 14.4183 18.1924 10 18.1924C8.15231 18.1924 6.45092 17.566 5.0966 16.514L16.3216 5.28899C17.3736 6.64331 18 8.34469 18 10.1924ZM3.68189 15.1003L14.9079 3.87427C13.5528 2.82016 11.8497 2.19238 10 2.19238C5.58172 2.19238 2 5.7741 2 10.1924C2 12.0421 2.62778 13.7452 3.68189 15.1003ZM20 10.1924C20 15.7152 15.5228 20.1924 10 20.1924C4.47715 20.1924 0 15.7152 0 10.1924C0 4.66954 4.47715 0.192383 10 0.192383C15.5228 0.192383 20 4.66954 20 10.1924Z",
    fill: "#93999F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.157a257054174f0bce208a99402a67f7.svg";
export { ForwardRef as ReactComponent };